import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { fromJS } from "immutable";
import DefiHeaderLogo from "./DefiHeaderLogo";
const nullify = () => null;
const styles = theme => ({
  button: {
    textTransform: "none",
    float: "right",
    height: "48px",
    color: "#fff",
    fontSize: 14
  },
  header: {
    maxWidth: 315,
    maxHeight: 52
  },
  mobileHeader: {
    maxWidth: 170,
    maxHeight: 52
  },
  buttonMenu: {
    margin: theme.spacing(1),
    textTransform: "none",
    float: "left",
    height: "48px",
    color: "#fff"
  },
  input: {
    margin: "0px -3px",
    backgroundColor: "#fff",
    width: "100%",
    fontSize: "14px",
    padding: "5px 1px"
  },
  toolbar: {
    backgroundColor: "#334058",
    color: "#fff",
    height: "68px"
  },
  appBar: {
    // position: 'fixed',
    width: "100%",
    zIndex: 1200
  }
});
const renderQABar = () => {
  if (window.location.host.split('.qa.').length > 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-xs-12",
      id: "testEnvBar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "box"
    }, /*#__PURE__*/React.createElement("div", {
      id: "testEnv"
    }, /*#__PURE__*/React.createElement("span", null, "TEST ENVIRONMENT"))));
  }
};
class DefiHeader extends Component {
  constructor(props) {
    super(props);
    // componentWillUnmount() {
    //   this.state.mql.removeListener(this.setMediaData);
    // }
    this.setMediaData = () => {
      const mql = window.matchMedia("(min-width: ".concat(this.props.mobileWidth, "px)"));
      this.setState({
        mql,
        mobileStatus: !mql.matches
      });
    };
    this.handleToggleMenu = (bool, e) => {
      this.setState({
        menuOpen: bool,
        menuAnchorEl: e ? e.currentTarget : null
      });
    };
    this.renderMobileMenuItems = () => {
      return this.props.right.map((link, i) => {
        if (link.has("condition") && !link.get("condition")) {
          return null;
        }
        if (link.get("type") === "input") {
          return /*#__PURE__*/React.createElement("div", {
            key: i,
            style: {
              padding: "4px 16px"
            }
          }, /*#__PURE__*/React.createElement("form", {
            onSubmit: link.get("submit") || nullify
          }, /*#__PURE__*/React.createElement("input", {
            type: "text",
            placeholder: "Application Search",
            className: this.props.classes.input,
            onChange: link.get("onChange") || nullify
          })));
        }
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: i,
          style: {
            cursor: "default"
          }
        }, /*#__PURE__*/React.createElement("a", {
          style: {
            cursor: "pointer",
            color: "inherit",
            textDecoration: "none"
          },
          href: link.get("link") || "#",
          onClick: link.get("onClick") || nullify
        }, link.get("name")));
      });
    };
    this.renderMobileRight = () => {
      const right = this.props.right;
      if (right && right.size > 0) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
          "aria-label": "More",
          "aria-owns": "mobile-menu",
          "aria-haspopup": "true",
          onClick: e => this.handleToggleMenu(true, e),
          className: this.props.classes.button
        }, /*#__PURE__*/React.createElement(MoreVertIcon, null)), /*#__PURE__*/React.createElement(Menu, {
          id: "mobile-menu",
          anchorEl: this.state.menuAnchorEl,
          open: this.state.menuOpen,
          onClose: () => this.handleToggleMenu(false),
          style: {
            zIndex: 1600
          }
        }, this.renderMobileMenuItems()));
      }
    };
    this.renderDesktopRight = () => {
      const classes = this.props.classes;
      return this.props.right.reverse().map((link, i) => {
        if (link.has("condition") && !link.get("condition")) {
          return null;
        }
        if (link.get("mobileOnly")) {
          return null;
        }
        if (link.has("icon")) {
          return /*#__PURE__*/React.createElement(IconButton, {
            key: i,
            className: classes.button,
            "aria-label": link.get("name"),
            onClick: link.get("onClick") || nullify
          }, link.get("icon").toJS());
        }
        return /*#__PURE__*/React.createElement(Button, {
          key: i,
          className: classes.button,
          href: link.get("link") || "",
          onClick: link.get("onClick") || nullify
        }, link.get("name"));
      });
    };
    this.renderGridItems = () => {
      const _this$props = this.props,
        classes = _this$props.classes,
        logo = _this$props.logo,
        logoLink = _this$props.logoLink;
      const sidebarIcon = () => {
        if (this.props.toggleSidebar) {
          return /*#__PURE__*/React.createElement(Grid, {
            item: true
          }, /*#__PURE__*/React.createElement(IconButton, {
            "data-testid": "sidebar-icon",
            className: classes.buttonMenu,
            "aria-label": "Logout",
            onClick: () => this.props.toggleSidebar()
          }, /*#__PURE__*/React.createElement(MenuIcon, {
            focusable: "focusable"
          })));
        }
      };
      if (this.state.mobileStatus) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3
        }, sidebarIcon()), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Grid, {
          container: true,
          alignItems: "center",
          justify: "center"
        }, logo && /*#__PURE__*/React.createElement(DefiHeaderLogo, {
          logo: logo,
          logoLink: logoLink,
          className: classes.mobileHeader
        }))), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3
        }, this.renderMobileRight()));
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 4
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, sidebarIcon(), logo && /*#__PURE__*/React.createElement(DefiHeaderLogo, {
        logo: logo,
        logoLink: logoLink,
        className: classes.header
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 4
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, this.props.center)), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 4
      }, this.renderDesktopRight()));
    };
    this.mql = window.matchMedia("(min-width: ".concat(props.mobileWidth, "px)"));
    this.state = {
      mql: this.mql,
      menuOpen: false,
      menuAnchorEl: undefined,
      mobileStatus: this.mql.matches
    };
  }
  componentDidMount() {
    if (localStorage.mobile === "false") {
      return this.setState({
        mobileStatus: false
      });
    }
    this.state.mql.addListener(this.setMediaData);
    this.setMediaData();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.mobileWidth !== this.props.mobileWidth) {
      if (localStorage.mobile !== "false") {
        this.mql.removeListener(this.setMediaData);
        this.mql = window.matchMedia("(min-width: ".concat(this.props.mobileWidth, "px)"));
        this.mql.addListener(this.setMediaData);
        this.setMediaData();
      }
    }
  }
  render() {
    const _this$props2 = this.props,
      classes = _this$props2.classes,
      headerContainerClass = _this$props2.headerContainerClass;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderQABar(), /*#__PURE__*/React.createElement("div", {
      className: headerContainerClass
    }, /*#__PURE__*/React.createElement(AppBar, {
      "data-testid": "defi-header",
      className: classes.appBar,
      onClick: this.props.headerClick,
      position: this.props.position
    }, /*#__PURE__*/React.createElement(Toolbar, {
      className: classes.toolbar
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      alignItems: "center"
    }, this.renderGridItems())))));
  }
}
DefiHeader.defaultProps = {
  right: fromJS([]),
  toggleSidebar: null,
  center: null,
  headerClick: nullify,
  mobileWidth: 1250,
  logo: "",
  logoLink: "",
  position: "fixed"
};
export default withStyles(styles)(DefiHeader);